import { render, staticRenderFns } from "./householdSolution.vue?vue&type=template&id=2a19340d&scoped=true"
import script from "./householdSolution.vue?vue&type=script&lang=js"
export * from "./householdSolution.vue?vue&type=script&lang=js"
import style0 from "./householdSolution.vue?vue&type=style&index=0&id=2a19340d&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a19340d",
  null
  
)

export default component.exports